import { AvatarUpload } from './AvatarUpload';
import { DropUpload } from './DropUpload';
import { Upload as UploadComponent } from './Upload';
import { FileList } from './components/FileList';
import { FileClass } from './rc-upload';
export var Upload = Object.assign(UploadComponent, {
  AvatarUpload: AvatarUpload,
  DropUpload: DropUpload,
  FileClass: FileClass,
  FileList: FileList
});
export { FileStatus, FileType } from './rc-upload';